import imgLoad from 'modules/imgload.js';
import $ from 'jquery';
import setNav from 'modules/setnav';
import nav from 'modules/nav';
import workThumbs from 'modules/workthumbs';
import sequence from 'modules/sequence';
import itemHover from 'modules/item-hover';

/***** Get it goin' *****/
document.addEventListener('DOMContentLoaded', () => {
  setNav();
  imgLoad();
  nav();
  workThumbs();
  sequence();
  itemHover();
}, false);



// WEBPACK FOOTER //
// ./source/scripts/scripts/init.js